import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";
import clsx from "clsx";

import formImg from "../../../assets/payment/form.png";
import PrimaryBtn from "../../../utils/PrimaryBtn/PrimaryBtn";

const inputStyle =
  "border-[#666666] border rounded-md px-3 py-2 text-sm outline-none focus:border-[#666666] focus:border";
const labelStyle = "text-[#4A4A4A] font-medium text-base mb-1";
const formField = "flex flex-col ";

const DialogDemo = ({ children }) => {
  const [open, setOpen] = React.useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger className='w-full' >{children}</DialogTrigger>
      <DialogContent
        className=" bg-secondary  sm:max-w-[525px]"
        hideCloseButton>
        <div className="sm:max-w-[400px] m-auto">
          {" "}
          <img className="max-w-52 m-auto" src={formImg} alt="formImg" />
          <DialogTitle className="text-textColor text-2xl font-medium text-center">
            We are <span className="text-[#E87C1E]">here</span> to lift up your{" "}
            <span className="text-[#E87C1E]">Career</span> !!!
          </DialogTitle>
          <form className="flex flex-col gap-4 " action="">
            <div className={formField}>
              <label className={clsx(labelStyle)} htmlFor="name">
                Name
              </label>
              <input
                className={clsx(inputStyle)}
                id="name"
                type="text"
                placeholder="Enter your name"
              />
            </div>
            <div className={formField}>
              <label className={clsx(labelStyle)} htmlFor="phone">
                Phone Number
              </label>
              <input
                className={clsx(inputStyle)}
                type="text"
                id="phone"
                placeholder="Enter your Phone number"
              />
            </div>
            <div className={formField}>
              <label className={clsx(labelStyle)} htmlFor="email">
                Email ID
              </label>
              <input
                className={clsx(inputStyle)}
                type="email"
                id="email"
                placeholder="Enter your Email Id"
              />
            </div>
          </form>
          <div className="mt-6 pb-4">
            <PrimaryBtn width="100%" padding="8px 0px">
              Next
            </PrimaryBtn>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DialogDemo;
